<template>
  <div class="task-list-view">
    <MCard :title="$t('任务列表')" title-align="center" ref="content">
      <div class="operation-area">
        <el-button type="primary" @click="newTaskHandler">{{ $t('新增') }}</el-button>
      </div>

      <div class="task-box">
        <MTable
          class="s-table"
          :tableData="tableData"
          :tableColumn="tableColumn"
          :oprateMenu="oprateMenu"
          :pagiOption="paginationCfg"
        />
      </div>
    </MCard>

    <!-- 新增、编辑任务 -->
    <el-dialog
      class="page-dilog"
      :title="saveTaskDialogType === 'add' ? $t('新增') : $t('编辑')"
      :visible.sync="saveTaskDialogVisable"
      width="30%"
      :before-close="colseTaskDialogHandler"
      :append-to-body="fullScreenFlag"
      :modal-append-to-body="false"
    >
      <el-form ref="form" :rules="rules" :model="form" label-width="150px">
        <el-form-item :label="$t('任务名称')" prop="name">
          <el-input v-model="form.name"></el-input>
        </el-form-item>

        <el-form-item :label="$t('地址')" prop="pointName">
          <el-input v-model="form.pointName"></el-input>
        </el-form-item>

        <el-form-item :label="$t('开始时间')" prop="beginTime">
          <el-date-picker
            v-model="form.beginTime"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            :append-to-body="fullScreenFlag"
          ></el-date-picker>
        </el-form-item>

        <el-form-item :label="$t('结束时间')" prop="endTime">
          <el-date-picker
            v-model="form.endTime"
            value-format="yyyy-MM-dd HH:mm:ss"
            type="datetime"
            :append-to-body="fullScreenFlag"
          ></el-date-picker>
        </el-form-item>

        <el-form-item :label="$t('任务描述')">
          <el-input type="textarea" v-model="form.remarks" autosize></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="colseTaskDialogHandler">{{ $t('取消') }}</el-button>
        <el-button type="primary" @click="saveTaskHandler">{{ $t('确定') }}</el-button>
      </span>
    </el-dialog>

    <!-- 删除  -->
    <el-dialog
      class="page-dilog"
      :title="$t('提示')"
      :visible.sync="delDialog"
      :append-to-body="fullScreenFlag"
      width="20%"
    >
      <span>{{ $t('删除内容') }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="delDialog = false">{{ $t('取消') }}</el-button>
        <el-button type="danger" @click="delTaskConfirmHandler">{{ $t('确定') }}</el-button>
      </span>
    </el-dialog>

    <executeTaskView
      v-if="showTaskDom"
      :taskId="taskId"
      :deviceList="deviceList"
      ref="taskDialog"
      @closeTask="taskId = ''"
    />

    <executeRecordView
      v-if="showRecordDom"
      :taskId="taskId"
      :deviceList="deviceList"
      ref="dialogUpdate"
      @clearTask="taskId = ''"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import mixins from '../utils/mixins';
import MCard from '@/components/mCard/index';
import HeaderIcon from '@/assets/image/components/warinIcon.png';
import executeTaskView from '../components/flight-task/execute-task.vue';
import executeRecordView from '../components/flight-task/execute-record.vue';
import MTable from '@/components/mTable/m-table';

import {
  flightMissionListServer,
  saveFlightTaskServer,
  deleteFlightTaskServer
} from '@/api/flight-task';

import { isEmpty } from '@/utils/is';

export default {
  mixins: [mixins],

  computed: {
    ...mapState('app', ['fullScreenFlag']),
    tableColumn() {
      return [
        { prop: 'name', label: this.$t('任务名称') },
        { prop: 'pointName', label: this.$t('地址') },
        { prop: 'beginTime', label: this.$t('开始时间') },
        { prop: 'endTime', label: this.$t('结束时间') },
        { prop: 'remarks', label: this.$t('描述') }
      ];
    },
    oprateMenu() {
      return {
        label: this.$t('操作'),
        width: 200,
        list: [
          {
            text: this.$t('编辑'),
            access: () => {
              return true;
            },
            event: (_index, data) => {
              this.editTaskHandler(data);
            }
          },
          {
            text: this.$t('删除'),
            access: () => {
              return true;
            },
            event: (_index, data) => {
              this.beforeDelTaskHandle(data);
            }
          },
          {
            text: this.$t('执行任务'),
            access: () => {
              return true;
            },
            event: (_index, data) => {
              this.executeTaskHandler(data);
            }
          },
          {
            text: this.$t('执行记录'),
            access: () => {
              return true;
            },
            event: (_index, data) => {
              this.openExecuteRecordHandler(data);
            }
          }
        ]
      };
    }
  },
  components: {
    MCard,
    MTable,
    executeTaskView,
    executeRecordView
  },

  data() {
    return {
      showRecordDom: false,
      showTaskDom: false,
      paginationCfg: {
        offset: 1,
        limit: 10,
        total: 0,
        layout: 'total,  prev, pager, next'
      },
      icon: {
        type: 'image',
        config: {
          src: HeaderIcon
        }
      },
      tableData: [],
      saveTaskDialogVisable: false,
      saveTaskDialogType: '',
      showPopconfirm: false,
      form: {
        name: '',
        pointName: '',
        beginTime: '',
        endTime: '',
        remarks: ''
      },
      rules: {
        name: [{ required: true, message: '请输入任务名称', trigger: 'blur' }],
        pointName: [{ required: true, message: '请输入地点', trigger: 'blur' }],
        beginTime: [{ type: 'string', required: true, message: '请选择日期', trigger: 'change' }],
        endTime: [{ type: 'string', required: true, message: '请选择日期', trigger: 'change' }]
      },
      executeTaskDialogVisable: false,
      taskForm: {
        sn: '',
        flightStartTime: '',
        flightEndTime: '',
        remarks: ''
      },
      taskRules: {
        sn: [{ required: true, message: '请选择设备', trigger: 'blur' }],
        flightStartTime: [
          { type: 'string', required: true, message: '请选择日期', trigger: 'change' }
        ],
        flightEndTime: [
          { type: 'string', required: true, message: '请选择日期', trigger: 'change' }
        ]
      },
      taskId: '',
      delDialog: false
    };
  },
  mounted() {
    this.selectList = [];
    this.initTakList();
  },
  methods: {
    handleCurrentChange(e) {
      this.paginationCfg.offset = e;
      this.initTakList();
    },
    initTakList() {
      const { offset, limit } = this.paginationCfg;
      flightMissionListServer({ offset, limit }).then(res => {
        this.tableData = res.data.list;
        this.paginationCfg.total = res.data.total;
      });
    },

    newTaskHandler() {
      this.form = {
        name: '',
        pointName: '',
        beginTime: '',
        endTime: '',
        remarks: ''
      };
      this.saveTaskDialogVisable = true;
      this.saveTaskDialogType = 'add';
    },
    editTaskHandler(val) {
      this.form = val;
      this.saveTaskDialogType = 'edit';
      this.saveTaskDialogVisable = true;
    },
    beforeDelTaskHandle(val) {
      this.selectList.push(val);
      this.delDialog = true;
    },

    delTaskConfirmHandler() {
      if (isEmpty(this.selectList)) return this.$message.warning('请选择一项任务');
      deleteFlightTaskServer({ id: this.selectList[0].id }).then(res => {
        if (res.code == 200) {
          this.$message.success(this.$t('deleteSuccess'));
          this.tableData.forEach((item, index) => {
            if (item.id === this.selectList[0].id) {
              this.tableData.splice(index, 1);
            }
          });
          this.delDialog = false;
        }
      });
    },

    saveTaskHandler() {
      this.$refs.form.validate(valid => {
        if (valid) {
          saveFlightTaskServer(this.form).then(res => {
            if (res.code == 200) {
              this.$message.success(this.$t('保存成功'));
              this.colseTaskDialogHandler();
              this.initTakList();
            }
          });
        }
      });
    },
    colseTaskDialogHandler() {
      this.form = {
        name: '',
        pointName: '',
        beginTime: '',
        endTime: '',
        remarks: ''
      };
      this.saveTaskDialogVisable = false;
    },

    executeTaskHandler(val) {
      this.taskId = val.id;
      this.showTaskDom = true;
      this.$nextTick(() => {
        this.$refs.taskDialog.visible = true;
      });
    },

    openExecuteRecordHandler(val) {
      this.taskId = val.id;
      this.showRecordDom = true;
      this.$nextTick(() => {
        this.$refs.dialogUpdate.visible = true;
      });
    }
  }
};
</script>

<style lang="scss">
.page-dilog .el-dialog {
  background-color: var(--drone-dialog-date-picker-bg-color) !important;
  .el-input__inner,
  .el-textarea__inner {
    background-color: var(--drone-dialog-date-picker-bg-color) !important;
  }
}
</style>

<style lang="scss">
.task-list-view {
  height: 100%;
  width: calc(100% - 100px);
  padding: 20px;
  box-sizing: border-box;

  .m-card_content {
    padding: 20px !important;
    box-sizing: border-box;
    overflow: auto;

    @include scrollar-style-thin;
    .operation-area {
      margin-bottom: 15px;
      box-sizing: border-box;
      text-align: right;
    }
    .task-box {
      box-sizing: border-box;
      /*  将全选项隐藏 */
      ::v-deep .section-table thead .el-table-column--selection .cell {
        display: none;
      }
    }
  }
}
</style>
